import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import LaundryCarosle from "./LaundryCarosle";
import Sar from "../assets/images/icons/Sar";
import { useCartStore } from "../store/useStore";
import SpaCarosle from "./SpaCarosle";

const ViewStationaryCartModal = ({
  stationaryId,
  show,
  handleClose,
  services,
  stationary_uuid,
  itemChange,
  is_express,
  service_fee,
  vat,
  discount_percentage,
  min_amount,
  data,
  images,
  use_banners_in_popup,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [count, setCount] = useState(1);

  const currency = localStorage.getItem("currency");

  const { stationaryCart, setStationaryCart } = useCartStore((state) => ({
    stationaryCart: state.stationaryCart,
    setStationaryCart: state.setStationaryCart,
  }));

  const categories = useMemo(() => {
    const stationaryServices = Array.isArray(services) ? services : [];
    console.log("stationaryServices", stationaryServices);
    return stationaryServices
      .map((category, idx) => ({
        ...category,
        id: category?.category_id ?? `category-${idx}`,
        name: category?.category_name || t("Category"),
        items: (category?.services || []).map((item) => ({
          ...item,
          id: item?.service_id ?? item?.id,
          name: item?.service_name || item?.name,
        })),
      }))
      .filter((category) => category?.items?.length > 0);
  }, [services, t]);

  const currentItems = selectedCategory?.items || [];

  const setCartItem = (item) => {
    const tempCart = [...JSON.parse(JSON.stringify(stationaryCart)), item];
    setStationaryCart(tempCart);
  };

  const handleEdit = () => {
    if (!itemChange || !selectedCategory || !selectedItem) {
      return;
    }

    const updated = stationaryCart.map((item) => {
      if (Number(item.id) === Number(itemChange.id)) {
        return {
          ...item,
          ...selectedItem,
          id: selectedItem?.id,
          name: selectedItem?.name,
          quantity: Number(count),
          category: selectedCategory?.name,
          category_id: selectedCategory?.category_id ?? selectedCategory?.id,
          service_id: selectedItem?.service_id ?? selectedItem?.id,
          price: selectedItem?.price,
        };
      }

      return item;
    });

    setStationaryCart(updated);
    handleClose();
  };

  useEffect(() => {
    if (!show) {
      setSelectedCategory(null);
      setSelectedItem(null);
      setCount(1);
    }
  }, [show]);

  useEffect(() => {
    if (itemChange && show) {
      setSelectedItem(itemChange);
      setCount(itemChange?.quantity || 1);

      const matchedCategory = categories.find((cat) =>
        cat.items.some(
          (item) =>
            Number(item?.id) ===
            Number(itemChange?.id || itemChange?.service_id),
        ),
      );
      if (matchedCategory) {
        setSelectedCategory(matchedCategory);
      }
    }
  }, [itemChange, show, categories]);

  const handleIncrease = () => {
    setCount((prev) => (prev > 1 ? prev - 1 : 1));
    ReactGA.event({
      category: "Decrease count in stationary page",
      action: "Click",
      value: `count: ${count}`,
    });
  };

  const handleDecrease = () => {
    setCount((prev) => prev + 1);
    ReactGA.event({
      category: "Increase count in stationary page",
      action: "Click",
      value: `count: ${count}`,
    });
  };

  const handleSubmit = () => {
    ReactGA.event({
      category: "Submit add item in stationary page",
      action: "Click",
      value: `room: ${room_uuid}`,
    });
    if (!selectedCategory || !selectedItem) {
      return;
    }

    if (itemChange) {
      handleEdit();
      return;
    }

    if (rawPath.split("/")[2] !== "StationaryOrderPayment") {
      navigate(`/${room_uuid}/StationaryOrderPayment`);
    }

    setCartItem({
      ...selectedItem,
      quantity: Number(count),
      category: selectedCategory?.name,
      category_id: selectedCategory?.category_id ?? selectedCategory?.id,
      service_id: selectedItem?.service_id ?? selectedItem?.id,
      price: selectedItem?.price,
    });

    setSelectedItem(null);
    setCount(1);
    handleClose();
  };

  const price = Number(selectedItem?.price || 0) * Number(count || 1);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="laundary-modal custom-width b-r"
    >
      <Modal.Body>
        <Button className="close-btn" onClick={handleClose}>
          <div className="close-btn-wrap"></div>
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height=".45em"
              viewBox="0 0 384 512"
            >
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
          </div>
        </Button>

        <div className="laundray-img-container">
          {/* <LaundryCarosle headerImages={images} /> */}
          <SpaCarosle noDots={true} autoPlay={true} stationary={true} />
        </div>

        <div className="clear"></div>

        <div className="full-div padd-div add-item">
          <i className="fa fa-plus-square" style={{ color: "#00638E" }}></i>
          <p>{t("Add Item")}</p>
        </div>

        <div className="full-div padd-div">
          <div className="flex justify-content-center drop-container">
            <Dropdown
              value={selectedCategory}
              onChange={(e) => {
                setSelectedCategory(e.value);
                setSelectedItem(null);
              }}
              panelClassName="panel-drop tar"
              options={categories}
              optionLabel="name"
              placeholder={t("Select a Category")}
              className="w-full md:w-14rem tar"
            />
          </div>

          <div className="flex justify-content-center drop-container mt-3">
            <Dropdown
              value={selectedItem}
              onChange={(e) => setSelectedItem(e.value)}
              panelClassName="panel-drop"
              options={currentItems}
              optionLabel="name"
              placeholder={t("Select Item")}
              className="w-full md:w-14rem"
              disabled={!selectedCategory}
              emptyMessage={t("No items found")}
            />
          </div>

          <div className="d-flex justify-content-between py-3 align-items-center flex-wrap mt-2">
            <Form.Group
              className="mb-3 d-flex align-items-center"
              controlId="stationaryCount"
            >
              <Form.Label className="count">{t("Count")}</Form.Label>
              <div className="count-order-amount mx-2">
                <Button className="small" onClick={handleIncrease}>
                  <i className="fa fa-minus"></i>
                </Button>
                <p>{count}</p>
                <Button className="small" onClick={handleDecrease}>
                  <i className="fa fa-plus"></i>
                </Button>
              </div>
            </Form.Group>

            {price > 0 ? (
              <div className="d-flex">
                <Form.Label className="mr-2 f-16">{t("Price")}</Form.Label>
                <p className="f-16 discount_percentage">
                  {currency === "SAR" ? (
                    <Sar color="currentcolor" />
                  ) : (
                    `${currency} `
                  )}
                  {price}
                </p>
              </div>
            ) : null}
          </div>

          <Row className="mt-4">
            <Col lg="6" md="6" xs="6" className="p-0 pl-2">
              <Button
                className="reg-btn big laundary-btn"
                onClick={handleSubmit}
                disabled={!selectedItem || !selectedCategory}
              >
                {itemChange ? t("Edit") : t("Add")}
              </Button>
            </Col>
            <Col lg="6" md="6" xs="6" className="p-0 px-2">
              <Button
                className="reg-btn big laundary-btn cancel"
                onClick={handleClose}
              >
                {t("Cancel")}
              </Button>
            </Col>
          </Row>
        </div>

        <div className="spacer-10"></div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewStationaryCartModal;
